import React from 'react';
import styles from './Switch.module.css';

interface SwitchProps {
    isToggled: boolean;
    onClick: () => void;
    disabled?: boolean;
    label?: string;
    className?: string;
}

const Switch: React.FC<SwitchProps> = ({ isToggled, onClick, disabled = false, label = '', className = '' }) => {
    return (
        <div className={`${styles.switchContainer} ${className}`}>
            {label && <span className={styles.switchLabel}>{label}</span>}
            <label className={styles.switch}>
                <input 
                    type="checkbox" 
                    checked={isToggled} 
                    onChange={onClick} 
                    disabled={disabled}
                    style={{ appearance: "none" }} 
                />
                <span className={`${styles.superAdminSlider} ${styles.superAdminRound} ${disabled ? styles.disabled : ""}`}></span>
            </label>
        </div>
    );
};

export default Switch; 